/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ShippingAdress from '../../../../components/Web/ShippingInfo/redesign/FunctionalRedesign/shippingAdress';
import * as shippingInfoActions from '../../actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import paymentInfo from '../../../PaymentInfo/sagas';
import shippingInfo from '../../reducer';
import * as ContactInfoActions from '../../../ContactInfo/actions';
import * as shippingInfoSelectors from '../../selectors/shippingInfoSelectors';

import * as cartActions from '../../../../services/Cart/actions';
import * as paymentActions from '../../../PaymentInfo/actions';
import * as getCheckOutActions from '../../../FuncComp/actions';
import { isPaymentNeeded } from '../../shippingHelper';

const mapStateToProps = (state) => {
  const getCheckOutDetailsState = state.checkout || {};
  const cart = state?.checkout?.cart;
  const selectedValue = state?.shippingInfo?.selectedValue;
  const addressChangeRequired = state?.checkout?.shipment?.lines?.newLine1?.addressChangeRequired;
  const shippingAddAAL = state?.checkout?.cart?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.primaryUserInfo?.address;
  const defaultShippingAddAAL = state?.checkout?.shipment?.lines?.newLine1?.address;
  const totalDueToday = state?.checkout?.orderDetails?.totalDueToday || 0;
  const primaryUserInfo = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.primaryUserInfo;
  const ispuContactInfo = state?.checkout?.cart?.lineDetails?.lineInfo?.newLine1?.shipping?.ispuContactInfo;
  const depletionType = state?.checkout?.depletionType || '';

  const devices = state?.checkout?.smsEnabledDevice?.smsEnabledDevice;
  const preAuthorized = state?.checkout?.smsEnabledDevice?.preAuthorized;
  const selectShippingData = shippingInfoSelectors.selectShippingDataFun(state);
  const shippingInfoState = state.shippingInfo;
  const { shippingInvalidError, apiFailureError, updateShippingAdressResponse } = shippingInfoState;

  const invalidAdressUnitCode = updateShippingAdressResponse?.errors ? updateShippingAdressResponse?.errors[0]?.id : '';
  const updateAddressApiError = updateShippingAdressResponse?.errors || [];
  const currentView = state.currentView || {};
  const shippingInfoDetails = state.shippingInfo.ShippingInfoDetails || {};
  const sddSlots = state.shippingInfo.sddSlots || {};
  const selectedShippingOption = state.shippingInfo.selectedShippingOption || {};
  const securePinData = state.shippingInfo.securePinData || {};
  const cartDetails = state.cartDetails && state.cartDetails.cartDetailsJson ? state.cartDetails.cartDetailsJson : {};

  const orderDetails = cartDetails && cartDetails.orderDetailsView ? cartDetails.orderDetailsView : {};
  const securePinDataDeviceSucess = state.shippingInfo.securePinDataDeviceSucess || {};
  const commonData = state.shippingInfo.commonData || {};
  const getSmsSuccess = state.shippingInfo.getSmsSuccess || {};
  const marketDetails = state.shippingInfo.marketDetails || {};
  const shippingAddress = state.cartDetails ? state.cartDetails.cartDetailsJson && state.cartDetails.cartDetailsJson.shippingDetails : {};
  const validateOrder = state?.cartDetails?.validateOrder || {};
  const creditStatus = validateOrder?.orderDetails?.[0] || {};
  const isCreditHold = creditStatus && creditStatus.creditApprovalStatus && creditStatus.creditApprovalStatus !== 'AP';
  const isCreditStatusAvailable =
    isCreditHold || validateOrder.downpaymentRequired || (validateOrder.errorMessage && validateOrder.errorMessage !== '');
  const creditStatusLanded = state.creditStatus?.creditStatusLanded;
  const paymentInfoState = state && state.paymentInfo;
  const paymentOptions = state?.checkout?.payment?.paymentOptions;
  const paymentOptionsAddedForAcct = state?.checkout?.lineDetails?.payments;
  const smsEnabledDevices = state?.shippingInfo?.securePinDataDeviceSucess?.fetchSMSEnabledDevices || [];
  const smsEnabledDeviceCount = smsEnabledDevices.length || 0;
  const pinVerified = state?.shippingInfo?.otpValidated || '';
  const addressChangeRsnCode = state?.checkout?.shipment?.lines?.newLine1?.addressChangeRsnCode || '';

  const payments = [];
  if (paymentOptions) {
    Object.keys(paymentOptions).forEach((data) => {
      const payment = paymentOptions[data];
      payments.push(payment);
    });
  }

  let otherPaymentOptions = [];
  let savedcardOption = payments && payments.filter((item) => item.paymentType === 'CR' && item.savedCCList && item.savedCCList.length !== 0);
  savedcardOption = savedcardOption && savedcardOption.map((obj) => ({ ...obj, paymentType: 'SC' }));
  otherPaymentOptions = payments && payments.concat(savedcardOption); // paymentOptions && [...paymentOptions,  ...savedcardOption];
  const isBTAAvailable = otherPaymentOptions && otherPaymentOptions.filter((item) => item.paymentType === 'AC');

  const isBTAEligible = state && state.shippingInfo && state.shippingInfo.isBTAEligible;
  const isbillingInfoEdited = state.contactInfo && state.contactInfo.billingInfoEdited ? state.contactInfo.billingInfoEdited : false;
  const updateValidateOTPResponse = shippingInfoState?.updateValidateOTPResponse;

  const isEmailSuccess = state.shippingInfo ? state.shippingInfo.emailAPiResponse : {};
  const { accMainEmailVal } = state.shippingInfo;
  const { emailMaxAttempts } = state.shippingInfo;

  const isPaymentNeed = isPaymentNeeded(paymentOptionsAddedForAcct);

  const { availableAddressUnit } = state.cartDetails;
  const shippingAddress2UnitCount = state.shippingInfo?.shippingAddress2UnitItems;
  const unitArray = state.shippingInfo?.shippingAddress2UnitArray;
  const shippingAddressEdit = state.shippingInfo?.shippingAddressEdit;
  const cart5GAddress = state?.checkout?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.cart5GAddress;
  const shippingAddressRadio = state.shippingInfo?.shippingAddressRadio;
  const cradleResponseDetails = state.SessionValues?.shippingCradleValue;
  const showPickupInfoTab = state.shippingInfo?.showPickupInfoTab;

  return {
    showPickupInfoTab,
    ispuContactInfo,
    getCheckOutDetailsState,
    shippingAddAAL,
    defaultShippingAddAAL,
    addressChangeRequired,
    selectShippingData,
    currentView,
    orderDetails,
    shippingInfoState,
    shippingInfoDetails,
    selectedShippingOption: selectedShippingOption || {},
    sddSlots,
    securePinData,
    securePinDataDeviceSucess,
    getSmsSuccess,
    shippingAddress,
    cartDetails,
    commonData,
    marketDetails,
    isCreditStatusAvailable,
    creditStatusLanded,
    paymentInfoState,
    isBTAAvailable,
    isBTAEligible,
    otherPaymentOptions,
    isbillingInfoEdited,
    updateValidateOTPResponse,
    isEmailSuccess,
    accMainEmailVal,
    emailMaxAttempts,
    addressList: state?.cartDetails?.availableAddress ? state?.cartDetails?.availableAddress?.addresses : [],
    isEmptyAddress: state?.cartDetails?.isEmptyAddress || false,
    isPOBoxAddress: state?.cartDetails?.isPOBoxAddress || false,
    shippingInvalidError,
    apiFailureError,
    devices,
    preAuthorized,
    totalDueToday,
    depletionType,
    isPaymentNeed,
    primaryUserInfo,
    selectedValue,
    cart,
    availableAddressUnit,
    appConfigValue: state?.cartDetails?.appConfig ? state?.cartDetails?.appConfig : false,
    unitlist: state?.cartDetails?.availableAddressUnit2 ? state?.cartDetails?.availableAddressUnit2?.data : [],
    shippingAddress2UnitCount,
    unitArray,
    shippingAddressEdit,
    cart5GAddress,
    shippingAddressRadio,
    cradleResponseDetails,
    smsEnabledDevices,
    smsEnabledDeviceCount,
    pinVerified,
    addressChangeRsnCode,
    invalidAdressUnitCode,
    updateAddressApiError,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...shippingInfoActions,
      ...cartActions,
      ...ContactInfoActions,
      ...paymentActions,
      ...getCheckOutActions,
    },
    dispatch,
  );
}

const withReducer = compose(injectReducer({ key: 'shippingInfo', reducer: shippingInfo }), injectSaga({ key: 'paymentInfo', saga: paymentInfo }));

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = injectSaga({ key: 'shippingInfo', saga });

export default withRouter(compose(withSaga, withReducer, withConnect)(ShippingAdress));
